import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=1350d0a9&scoped=true"
import script from "./SupportChat.vue?vue&type=script&lang=js"
export * from "./SupportChat.vue?vue&type=script&lang=js"
import style0 from "./SupportChat.vue?vue&type=style&index=0&id=1350d0a9&prod&scoped=true&lang=css"
import style1 from "./SupportChat.vue?vue&type=style&index=1&id=1350d0a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350d0a9",
  null
  
)

export default component.exports